<template>
    <div>
        <div class="flex flex-wrap items-start justify-between gap-3 mb-7">
            <div class="flex flex-wrap items-center gap-3 text-xs uppercase tracking-wide flex-1">
            <span v-if="model.New" class="border px-2 py-1  text-workbook-black">New style</span>
            <span v-else-if="model.NewColour" class="border border-workbook-black px-2 py-1 inline-flex items-center gap-1">
                
                New colour
            </span>
            <span v-else-if="model.Revised" class="border border-workbook-black px-2 py-1 inline-flex items-center gap-1 text-workbook-black">Revised</span>
            <span v-if="model.ExploreLineOverview" class="bg-neutral-200 px-2 py-1">Explore</span>
            <span v-if="model.RoadLineOverview || model.GravelLineOverview || model.TrailLineOverview"
                class="bg-neutral-200 px-2 py-1">Cycling</span>
            <span class="text-neutral-900 font-normal text-base">Model #{{ model.Style }}</span>
            <span v-if="model.ProductFit" class="pt-1">{{ model.ProductFit }} Fit</span>
            </div>
            <div class="shrink-0">
                <slot name="top-right" />
            </div>
        </div>
        <h2 class="text-[42px] font-normal mb-6">
            {{ model.name }}
        </h2>

        <div v-if="model.ProductDescription">
            <p class="text-xl text-neutral-700 mb-3 whitespace-pre-line">
                {{ model.ProductDescription }}
            </p>
        </div>

        <!-- PRICING -->
        <div class="w-full flex text-sm text-neutral-700 pricing mb-8 lg:mb-8">
            <p>
                <strong>WS:</strong> {{ formatNumber(wsPrice, settings.currency) }}
                <span class="ml-4"><strong>MSRP:</strong> {{ formatNumber(msrpPrice, settings.currency) }}</span>
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { formatNumber } from '@/utils/formatNumber'
import type { ProductModel } from '~/types/catalog';
import { useSettingsStore } from '@/store/settings'
const settings = useSettingsStore()
const props = defineProps({
  
  model: {
    type: Object as () => ProductModel,
  }
})

// Rätt prisfält per valuta
const wsPrice = computed(() => {
  switch (settings.currency) {
    case 'USD': return Number(props.model.WSUSD)
    case 'EUR': return Number(props.model.WSEUR)
    case 'GBP': return Number(props.model.WSGBP)
    case 'CHF': return Number(props.model.WSCHF)
    case 'CAD':
    default:
      return Number(props.model.WSCAD)
  }
})
const msrpPrice = computed(() => {
  switch (settings.currency) {
    case 'USD': return Number(props.model.MSRPUSD)
    case 'EUR': return Number(props.model.MSRPEUR)
    case 'GBP': return Number(props.model.MSRPGBP)
    case 'CHF': return Number(props.model.MSRPCHF)
    case 'CAD':
    default:
      return Number(props.model.MSRPCAD)
  }
})
</script>

<style scoped>
@reference "../../assets/css/main.css";

.pricing p {
  @apply mb-0;
}
</style>
